import React from "react";

export default function Marquee({ items = [], starsOnly = false }) {
  if (starsOnly) {
    return (
      <div className="border-y border-ink/15 py-3" data-testid="marquee-strip" />
    );
  }
  const content = items.length
    ? items
    : [
        "The Magicians' House",
        "West Norfolk",
        "Stoke Ferry",
        "Sleeps Twelve",
        "One Grand Piano",
        "No Televisions",
        "Opposite the Church",
      ];
  const loop = [...content, ...content];
  return (
    <div className="border-y border-ink/20 bg-parchment-cream-noise overflow-hidden" data-testid="marquee-strip">
      <div className="marquee-track py-4">
        {loop.map((t, i) => (
          <span
            key={i}
            className="font-sans text-[0.72rem] uppercase tracking-[0.3em] text-ink/60 px-8 whitespace-nowrap"
          >
            {t} <span className="text-ink/30 mx-2">·</span>
          </span>
        ))}
      </div>
    </div>
  );
}
